import React, { FC, ReactElement } from 'react'
import styles from './HeaderLink.module.css'
import classNames from 'classnames'

const HeaderSocialLink: FC<{
	href: string
	icon: React.FC<{
		className?: string
	}>
	name?: string
	className?: string
}> = (props): ReactElement => {
	return (
		<a
			className={classNames(styles.root, { [(props.className as any)]: !!props.className })}
			href={props.href}
			target="_blank"
		>
			<props.icon className={styles.icon} />
			{props?.name && props.name}
		</a>
	)
}

export default HeaderSocialLink
